<template>

	<div class="landing-notFound">
		<section class="container-fluid" v-in-viewport="" v-for="errors in errorPage">
			<div class="inner">
					<div class="image">
						<img src="/dist/404.png" alt="Page not found" class="img-responsive">
					</div>
					<div class="message">
						<h1 class="headline" v-in-viewport="">ERROR 404 </h1>
						<p>
							Sorry. Either you typed in the wrong URL, or one of the dogs around the agency ate the page you were looking for.
						</p>
						<router-link to="/" tag="button" class="btn_orange">HOME</router-link>
					</div>
					<div class="clearfix"></div>
		 	</div>
		</section>
	</div>

</template>

<script>
	import apiConnection from '../mixins/apiConnection.js';
	require('../assets/img/404.png');


	export default{
		name: 'NotFound',
		data () {
		   return {
		   		errorPage:[]
		   }
		},
		created(){
			this.getErrorsPage();
		},

		mixins:[apiConnection]


	}
</script>



// WEBPACK FOOTER //
// NotFound.vue?5058be2c